import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  try {
    if (response.error) {
      const customError = {
        message: response?.error?.message ?? 'Oops! something sent wrong',
        code: response?.error?.code,
      }
      throw customError
    } else {
      const retData = response?.data?.response?.instrumentList?.map((item: any) => ({
        id: item.id,
        name: item.name,
        rank: item.rank ?? -1,
        isPopular: item.popular ?? false,
        logo: item.imageUrl ? item.imageUrl : '',
        type: item.type,
      }))
      return retData
    }
  } catch (error) {
    throw error
  }
}

const getInstrumentsNew = (tokens: any, instrumentType?: number) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getInstruments),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: instrumentType ? { instrumentType: instrumentType } : {},
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getInstrumentsNew }
